import React, { useContext, useEffect, useState } from 'react';
import MobileContext from 'context/MobileContext';
import NotificationDesktop from './NotificationDesktop';
import NotificationMobile from './NotificationMobile';
import styles from './styles.module.css';
import Text from 'components/shared/Text';
import { CircularProgress } from '@material-ui/core';
import EmptyData from './EmptyData';
const NotificationNew = ({
  loadNotification,
  notification,
  updateNotification,
  updatedNotification,
  loadNotificationIsRequesting,
  updateNotificationIsRequesting,
}) => {
  let sfId = localStorage.getItem('sfId');
  const userID = localStorage.getItem('sfId');
  const isMobile = useContext(MobileContext);
  const [updateNotificationData, setupdateNotificationData] = useState('');
  const [openPopup, setopenPopup] = React.useState(false);
  const handleClosePopup = () => setopenPopup(false);

  const checkboxStyle = {
    color: 'var(--orange-color)',
  };

  const handleCheckboxChange = (id, booleanValue) => {
    const split = updateNotificationData.split(',');
    const isPresent = split.includes(id);
    if (isPresent && booleanValue === false) {
      const updateArray = split.filter(value => value !== id && value !== '');
      const joinValue = updateArray.join(',');
      setupdateNotificationData(joinValue);
    } else if (!isPresent && booleanValue === true) {
      split.push(id);
      const removeEmptyValue = split.filter(value => value !== '');
      const updatedEmailNotifications = removeEmptyValue.join(',');
      setupdateNotificationData(updatedEmailNotifications);
    } else if (!isPresent && booleanValue === false) {
      return;
    }
  };

  useEffect(() => {
    loadNotification(sfId);
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles.container}>
      <Text className={styles.mainHeading}>Notifications</Text>
      <div className={styles.child}>
        {loadNotificationIsRequesting && Object.keys(notification).length === 0 ? (
          <div className={styles.progressbarDiv}>
            <CircularProgress size={60} style={{ color: '#FE5000' }} />
          </div>
        ) : notification === null ? (
          <EmptyData />
        ) : isMobile ? (
          <NotificationMobile
            updateNotification={updateNotification}
            notification={notification}
            updateNotificationIsRequesting={updateNotificationIsRequesting}
            loadNotificationIsRequesting={loadNotificationIsRequesting}
            checkboxStyle={checkboxStyle}
            handleCheckboxChange={handleCheckboxChange}
            updateNotificationData={updateNotificationData}
            setupdateNotificationData={setupdateNotificationData}
            userID={userID}
            openPopup={openPopup}
            setopenPopup={setopenPopup}
            handleClosePopup={handleClosePopup}
            updatedNotification={updatedNotification}
          />
        ) : (
          <NotificationDesktop
            updateNotification={updateNotification}
            notification={notification}
            updateNotificationIsRequesting={updateNotificationIsRequesting}
            loadNotificationIsRequesting={loadNotificationIsRequesting}
            checkboxStyle={checkboxStyle}
            handleCheckboxChange={handleCheckboxChange}
            updateNotificationData={updateNotificationData}
            setupdateNotificationData={setupdateNotificationData}
            userID={userID}
            openPopup={openPopup}
            setopenPopup={setopenPopup}
            handleClosePopup={handleClosePopup}
            updatedNotification={updatedNotification}
          />
        )}
      </div>
    </div>
  );
};

export default NotificationNew;
